import { BRANDS, PRODUCTS } from '@/utilities/constants/game';

import { AllPopupTypes } from '../Popup/types';
import { iconMapper } from './helpers/iconMapper';

const ICON_PRODUCTS = {
  fanduel: BRANDS.FANDUEL,
  mohegansun: BRANDS.MOHEGANSUN,
  poker: PRODUCTS.POKER,
} as const;

export type IconProductType = keyof typeof ICON_PRODUCTS;
export type IconType = 'popup' | 'responsible_gambling' | 'logo';
export type PopupType = 'default' | 'null' | AllPopupTypes;
export type ResponsibleGamblingType =
  | 'default'
  | 'terms'
  | 'pa'
  | 'nj'
  | 'wv'
  | 'mi'
  | 'ct'
  | 'mr'
  | 'on';

export type LogoType = 'default' | 'landscape';

export type IconComponent = {
  icon: React.FC<{ size: number }> | null;
  size?: number;
};
type SubtypeMap<Subtype extends string> = {
  default: IconComponent;
} & Partial<Record<Exclude<Subtype, 'default'>, IconComponent>>;

export type IconSubTypeMapper = {
  popup: SubtypeMap<PopupType>;
  responsible_gambling: SubtypeMap<ResponsibleGamblingType>;
  logo: SubtypeMap<LogoType>;
};

export type SubtypeFor<T extends IconType> = T extends 'popup'
  ? PopupType
  : T extends 'responsible_gambling'
    ? ResponsibleGamblingType
    : T extends 'logo'
      ? LogoType
      : never;

export function getIconProductType(): IconProductType {
  const product = process.env.PRODUCT?.toLowerCase();
  const brand = process.env.BRAND?.toLowerCase();

  if (product && Object.keys(ICON_PRODUCTS).includes(product)) {
    return product as IconProductType;
  } else if (brand && Object.values(BRANDS).includes(brand)) {
    return brand as IconProductType;
  }

  return BRANDS.FANDUEL as IconProductType;
}

export function getIcon(
  product: IconProductType,
  type: IconType,
  subtype: SubtypeFor<typeof type>,
): IconComponent {
  if (!(product in iconMapper) || !(type in iconMapper[product])) {
    return { icon: null };
  }
  if (subtype in iconMapper[product][type]) {
    return iconMapper[product][type][subtype];
  }

  return iconMapper[product][type]['default'];
}
